import React from 'react';
import { AreaSVGProps } from '../VehiclePaintMeasurement.types';

/**
 * Komponent SVG dla obszaru D - sedan widok prawy
 */
export const AreaD_Sedan_Right: React.FC<AreaSVGProps> = ({
  fill = '#73C69B',
  stroke = '#73C69B',
  strokeWidth = 2,
  fillOpacity = 0.5,
  className = '',
}) => {
  return (
    <svg
      width="62"
      height="162"
      viewBox="0 0 62 162"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <filter
          id="filter_area_d_sedan_right"
          x="0"
          y="0"
          width="62"
          height="162"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>

      <g filter="url(#filter_area_d_sedan_right)">
        <path
          d="M53.807 5.4375C51.6457 6.6448 49.6125 7.77593 47.6908 8.83203C34.9873 15.8135 26.4922 19.9544 17.9388 20.6162C12.9669 21.0005 9.40154 19.5987 6.41736 17.4336C5.7668 16.9616 5.14855 16.4559 4.56677 15.9521C4.00975 46.1791 1.27781 125.398 1.0072 130.753C4.10891 140.946 7.09401 149.908 9.91052 156.845C10.2244 146.066 10.4662 135.798 10.4662 133.014C10.4662 128.405 11.4136 124.634 13.265 120.288L13.6469 119.41C13.6892 119.315 13.7344 119.221 13.7826 119.129H13.7836C15.5578 115.737 18.5522 112.115 23.4818 112.911C27.5694 113.571 29.66 117.141 30.4095 119.523C31.0883 121.679 31.563 124.14 31.9994 126.539C32.0383 126.753 32.0769 126.968 32.1156 127.183C32.156 127.406 32.1963 127.631 32.2367 127.856V127.858L32.2377 127.86C32.247 127.912 32.2567 127.964 32.266 128.016C33.1049 127.5 33.7085 127.042 34.1791 126.601C35.19 125.651 35.8945 124.501 36.8832 121.749C39.0189 115.804 42.8315 102.479 47.0013 86.8584C44.4358 82.9933 42.3439 78.8476 40.726 74.4922C37.8968 66.8757 36.5111 58.6216 36.5482 50.1172C36.6191 34.0038 41.9479 18.2876 52.9086 6.39062C53.2041 6.06983 53.5037 5.7522 53.807 5.4375Z"
          fill={fill}
          fillOpacity={fillOpacity}
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          shapeRendering="crispEdges"
        />
      </g>
    </svg>
  );
};
